// extracted by mini-css-extract-plugin
module.exports = {"userInfo":"UserInfo_userInfo__3W6Tz","r":"UserInfo_r__1TQP5"};